import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { EvaluatorTrainingTable } from '../../components';

// API
import { listEvaluatorTrainings } from  '../../api';

// Alerts
import { setError } from '../../alerts';

class Training extends Component {
  constructor(props) {
    super(props);

    this.state = {
      training: [],
      isLoading: false
    };
  }

  componentDidMount() {
    this.setState({ isLoading: true });
    listEvaluatorTrainings().then(({ results }) => {
      if (results != null) {
        this.setState({ training: results });
      }
      this.setState({ isLoading: false });
    }).catch((error) => {
      setError(error ?? 'Error: Could not retrieve training list.');
      this.setState({ isLoading: false });
    });
  }

  render() {
    return (
      <EvaluatorTrainingTable training={this.state.training} isLoading={this.state.isLoading} />
    );
  }
}

Training.propTypes = {
  match: PropTypes.object.isRequired
};

export default withRouter(Training);
